import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent('InfoMessage', 'registrationConfirmation', ['infoMessage']);